'use strict';

exports = module.exports = require('./lib/parser')['default'];
exports['default'] = exports;



//////////////////
// WEBPACK FOOTER
// ./~/intl-messageformat/~/intl-messageformat-parser/index.js
// module id = 899
// module chunks = 0 1 2 3 4